import { DEFAULT_WEBSITE_CONTENT } from '../config/defaults';

function digits(phone: string) {
  return phone.replace(/\D/g, '');
}

export function configuredStudioPhone(): string {
  const saved = window.localStorage.getItem('website_content');
  if (saved) {
    try {
      const parsed = JSON.parse(saved);
      if (parsed && typeof parsed.contactPhone === 'string' && parsed.contactPhone.trim()) return parsed.contactPhone.trim();
    } catch (_) {
      return DEFAULT_WEBSITE_CONTENT.contactPhone;
    }
  }
  return DEFAULT_WEBSITE_CONTENT.contactPhone || '';
}

export function clientWhatsAppUrl(quoteNumber: string, booking = false): string {
  const phone = configuredStudioPhone();
  const number = digits(phone);
  if (number.length < 8 || /123\s*4567/.test(phone)) return '';
  const kind = booking ? 'booking' : 'quotation';
  const text = `Hi Carmen, I have a question about my ${kind} ${quoteNumber}.`;
  return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
}
